module.exports = __webpack_public_path__ + "assets/img/IMG009.a632f939.png";